<template>
  <v-app>
    <v-main class="main-container">
      <router-view />
      <TheFooter />
    </v-main>
  </v-app>
</template>

<script>
import { useBibleStore } from './stores/bible';
import { useUserPreferencesStore } from './stores/userPreferences';
import { usePlanStore } from './stores/plan';
import { useProgressStore } from './stores/progress';
import { useAuthStore } from './stores/auth';
import { onMounted } from 'vue';
import TheFooter from './components/TheFooter.vue';

export default {
  name: 'App',
  components: {
    TheFooter
  },
  setup() {
    const bibleStore = useBibleStore();
    const prefsStore = useUserPreferencesStore();
    const planStore = usePlanStore();
    const progressStore = useProgressStore();
    const authStore = useAuthStore();

    onMounted(() => {
        // Initialize global data
        bibleStore.loadBibleData();
        prefsStore.init();
        progressStore.init();
        planStore.initPredefinedPlans();
        authStore.init();

        // Check for payment return
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('payment_success') === 'true') {
            // Clear param
            window.history.replaceState({}, document.title, window.location.pathname);
            
            // Reload user data to get updated subscription
            // We wait a bit to allow Firestore webhook to process
            setTimeout(() => {
                if (authStore.user) {
                    authStore.init(); // Re-init to fetch fresh doc
                    alert('Payment successful! Your premium features are active.');
                }
            }, 2000);
        }
    });

    return {};
  }
}
</script>

<style>
/* Global App Styles */
:root {
  --font-primary: 'Inter', sans-serif;
}

.v-application {
  font-family: var(--font-primary) !important;
  background-color: #0f1111 !important; /* Deep dark background */
}

.main-container {
  width: 90% !important;
  max-width: 1600px !important;
  margin: 0 auto !important;
  padding: 24px;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #0f1111;
}
::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
